// extracted by mini-css-extract-plugin
export default {"auction-explanation-panel__image":"auction-explanation-panel__image--1BHEK"};
    if(module.hot) {
      // 1747648148556
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  